import { Validator } from '@mc-alberta/vee-validate-legacy'
import cardBrand from '@/validations/cardBrand'
import expiryDate from '@/validations/expiryDate'
import nationalId from '@/validations/nationalId'
import noLeadingNumber from '@/validations/noLeadingNumber'

export function registerValidations() {
  const validations = [cardBrand, expiryDate, noLeadingNumber, nationalId]

  const registerValidation = ({ name, validator }) => {
    Validator.extend(name, validator)
  }

  validations.forEach(registerValidation)
}

export default {
  cardBrand,
  expiryDate,
  noLeadingNumber,
  nationalId
}
